import { render, staticRenderFns } from "./index.vue?vue&type=template&id=4fd31a95&"
import script from "./index.vue?vue&type=script&lang=js&"
export * from "./index.vue?vue&type=script&lang=js&"
import style0 from "./index.vue?vue&type=style&index=0&id=4fd31a95&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {ScheduleHead: require('/opt/yamal.ru/src/components/schedule/head.vue').default,RzPreloader: require('/opt/yamal.ru/node_modules/razlet-ui/src/components/preloader/index.vue').default,ScheduleTable: require('/opt/yamal.ru/src/components/schedule/table.vue').default,RzIconArrowThin: require('/opt/yamal.ru/node_modules/razlet-ui/src/icons/icon-arrow-thin/index.vue').default,RzButton: require('/opt/yamal.ru/node_modules/razlet-ui/src/components/button/index.js').default,RzContainer: require('/opt/yamal.ru/node_modules/razlet-ui/src/components/container/index.vue').default})
